import InformacieOCookies from './InformacieOCookies';

export default InformacieOCookies;
